<div mat-dialog-content autoFocus="false">
  <div class="wrapper">
    <div class="button-container">
      <button mat-icon-button mat-dialog-close color="accent" class="close-modal">
        <mat-icon aria-label="Close">close</mat-icon>
      </button>
    </div>

    <div class="email-info-container email-info"></div>

    <!-- Secondary Information Tabs -->
    <!-- the @.disabled stops the tab switching animation -->
    <mat-tab-group [@.disabled]="true">
      <!-- Details Tab -->
      <mat-tab label="Details">
        <!-- Email Information Pane -->
        <div class="email-info-container email-info">
          <div class="subject">
            <span class="info-label">Subject</span>
            {{ email.subject }}
          </div>

          <div class="email-to-from">
            <span class="info-label">To</span>
            @for (to of email.to; track to) {
              <div class="email-to-from">
                <span class="email-name">{{ to.name }}</span>
                <span class="email-email">({{ to.emailAddress }})</span>
              </div>
            }
          </div>

          <div class="email-info-data email-info-name">
            <span class="info-label">From</span>
            <span class="email-name">{{ email.from.name }}</span>
            <span class="email-email">({{ email.from.emailAddress }})</span>
          </div>
        </div>
      </mat-tab>

      <!-- Events Tab -->
      <mat-tab label="Events">
        @if (events$ | async; as events) {
          <mat-list class="event-list">
            @for (e of events; track e) {
              <mat-list-item>
                @switch (eventTypeToString(e.eventType)) {
                  @case ('OPENED') {
                    <mat-icon matListItemIcon>drafts</mat-icon>
                  }
                  @case ('DELIVERED') {
                    <mat-icon matListItemIcon>mail</mat-icon>
                  }
                  @case ('PROCESSED') {
                    <mat-icon matListItemIcon>send</mat-icon>
                  }
                  @case ('BOUNCED') {
                    <mat-icon matListItemIcon>trending_down</mat-icon>
                  }
                  @case ('DEFERRED') {
                    <mat-icon matListItemIcon>replay</mat-icon>
                  }
                  @case ('DROPPED') {
                    <mat-icon matListItemIcon>remove_circle_outline</mat-icon>
                  }
                  @default {
                    <mat-icon matListItemIcon>crop_square</mat-icon>
                  }
                }
                <h4 class="key" matListItemTitle>
                  {{ eventTypeToString(e.eventType) | titlecase }}
                </h4>
                <p matListItemLine>{{ e.eventTime | date: 'medium' }}</p>
              </mat-list-item>
            }
          </mat-list>
        } @else {
          <mat-list class="event-list">
            <mat-list-item>{{ 'EMAIL.NO_EVENTS' | translate }}</mat-list-item>
          </mat-list>
        }
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
